/**
 * Checks that a value is a non-NaN number type
 *
 * @param value - This accepts a value of any type in order to
 * @returns true if the given value is a number type AND is not strictly NaN,
 *   or false otherwise
 */
function isRealNumber(value) {
    return typeof value === 'number' && isFinite(value);
}
export default isRealNumber;
//# sourceMappingURL=is-real-number.js.map